export const forgotPasswordTranslations = {
  en: {
    'forgotPassword.emailPlaceholder': 'you@example.com',
    'forgotPassword.userNotFound': 'No account found with this email address',
    'forgotPassword.networkError': 'Unable to connect to server. Please check your connection and try again.',
    'forgotPassword.requestFailed': 'Password reset request failed',
  },
  es: {
    'forgotPassword.emailPlaceholder': 'tu@ejemplo.com',
    'forgotPassword.userNotFound': 'No se encontró ninguna cuenta con esta dirección de correo electrónico',
    'forgotPassword.networkError': 'No se puede conectar al servidor. Por favor, compruebe su conexión e inténtelo de nuevo.',
  },
  fr: {
    'forgotPassword.emailPlaceholder': 'vous@exemple.com',
    'forgotPassword.userNotFound': 'Aucun compte trouvé avec cette adresse e-mail',
    'forgotPassword.networkError': 'Impossible de se connecter au serveur. Veuillez vérifier votre connexion et réessayer.',
  },
  sq: {
    'forgotPassword.emailPlaceholder': 'ju@shembull.com',
    'forgotPassword.userNotFound': 'Nuk u gjet llogari me këtë adresë email',
    'forgotPassword.networkError': 'Nuk mund të lidhemi me serverin. Ju lutemi kontrolloni lidhjen tuaj dhe provoni përsëri.',
  },
  ru: {
    'forgotPassword.emailPlaceholder': 'вы@пример.com',
    'forgotPassword.userNotFound': 'Аккаунт с таким адресом электронной почты не найден',
    'forgotPassword.networkError': 'Не удалось подключиться к серверу. Проверьте подключение и попробуйте снова.',
  },

  de: {
    'forgotPassword.emailPlaceholder': 'sie@beispiel.com',
    'forgotPassword.userNotFound': 'Kein Konto mit dieser E-Mail-Adresse gefunden',
    'forgotPassword.networkError': 'Verbindung zum Server nicht möglich. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  },

  sr: {
    'forgotPassword.emailPlaceholder': 'vi@primer.com',
    'forgotPassword.userNotFound': 'Nije pronađen nalog sa ovom email adresom',
    'forgotPassword.networkError': 'Nije moguće povezati se sa serverom. Proverite vezu i pokušajte ponovo.',
  },
  pl: {
    'forgotPassword.emailPlaceholder': 'ty@przykład.com',
    'forgotPassword.userNotFound': 'Nie znaleziono konta z tym adresem email',
    'forgotPassword.networkError': 'Nie można połączyć się z serwerem. Sprawdź połączenie i spróbuj ponownie.',
  },
  el: {
    'forgotPassword.emailPlaceholder': 'εσείς@παράδειγμα.com',
    'forgotPassword.userNotFound': 'Δεν βρέθηκε λογαριασμός με αυτή τη διεύθυνση email',
    'forgotPassword.networkError': 'Αδυναμία σύνδεσης με τον διακομιστή. Παρακαλώ ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
  },
  ro: {
    'forgotPassword.emailPlaceholder': 'tu@exemplu.com',
    'forgotPassword.userNotFound': 'Nu a fost găsit niciun cont cu această adresă de email',
    'forgotPassword.networkError': 'Nu se poate conecta la server. Vă rugăm verificați conexiunea și încercați din nou.',
  },
  pt: {
    'forgotPassword.emailPlaceholder': 'voce@exemplo.com',
    'forgotPassword.userNotFound': 'Nenhuma conta encontrada com este endereço de email',
    'forgotPassword.networkError': 'Não é possível conectar ao servidor. Verifique sua conexão e tente novamente.',
  },
};
